import { SectionTitle, Faq } from '@/ui/index';
import { Support } from '@/icons/index';

import styles from './FaqContainer.module.scss';

const FaqContainer = ({ data: { title = '', faq = [] } }) => {
  return (
    <div
      className={'wrapper section'}
      itemScope
      itemType='https://schema.org/FAQPage'
    >
      {title && (
        <SectionTitle
          className={styles.title}
          Icon={Support}
          titleModify='title--large'
        >
          {title}
        </SectionTitle>
      )}
      {faq.length && <Faq items={faq} />}
    </div>
  );
};

export default FaqContainer;
